var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 44,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 44,
    rx: 8,
    stroke: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 20.0001L27.7367 27.7557C27.6032 29.4924 26.155 30.8334 24.4132 30.8334H20.5868C18.845 30.8334 17.3968 29.4924 17.2633 27.7557L16.6667 20.0001M30 18.3334C27.8351 17.2784 25.2614 16.6667 22.5 16.6667C19.7386 16.6667 17.1649 17.2784 15 18.3334M20.8333 16.6667V15.8334C20.8333 14.9129 21.5795 14.1667 22.5 14.1667C23.4205 14.1667 24.1667 14.9129 24.1667 15.8334V16.6667M20.8333 21.6667V26.6667M24.1667 21.6667V26.6667",
    stroke: "#2E3944",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.c243871ead840c789bf4ad3b84844025.svg";
export { ForwardRef as ReactComponent };